<template>
	<div class="regionalTranslationRightView" v-bind="$attrs">
		<div class="rightView_body">
		<!-- :class="{ 'setWidth':isUpdataJsonShow }" -->
		<div class="pageItem" v-for="(item, index) in jsonList" :key="item.page">
			<div class="pageItem_title_view common_display">
				<span class="pageItem_pageIndex">{{ `Page ${item.page}`}}</span>
				<span class="pageItem_selectNum">{{ `${$t('doclingo_selected')}${item.list.length}`}}</span>
			</div>
			<div class="pageItem_list_view common_display" v-for="it in item.list"
				:key="`${it.edit_rect_type}:${it.index}`">
				<div class="pageItem_list_item_typeTitle">{{ pageTypeTextfilter(it.edit_rect_type, it.index - 1) }}</div>
				<div class="common_display">
					<div class="pageItem_list_item_select">
						<el-select v-model="it.ignore_type" class="custom-select" effect="light" placement="bottom-end"
							:placeholder="$t('homePagePleaseChoose')" @change="updateShapeIgnoreType(item.canvasPage, it.index,
	it.ignore_type, it.edit_rect_type)">
							<el-option :label="$t('doclingo_all_ignore')" value="all" key="all"></el-option>
							<el-option :label="$t('doclingo_ocr_ignore')" value="image" key="image"></el-option>
							<el-option :label="$t('doclingo_text_ignore')" value="text" key="text"></el-option>
						</el-select>
					</div>
					<div class="pageItem_list_item_delete" @click="handleDeleteItem(item, it.edit_rect_type, it, index)">
						<i class="iconfont icon-icon_delete"></i>
					</div>
				</div>
			</div>
		</div>
		<div class="not_data" v-if="jsonList.length<1">
			<p class="not_data_title">{{ $t('doclingo_edit_regional_tips_title') }}</p>
			<p class="not_data_desc">{{ $t('doclingo_edit_regional_tips_desc') }}</p>
		</div>
		</div>
		<!-- :class="{ 'setBtnShow': isUpdataJsonShow }" -->
		<div class="retranslation_btn_view" v-if="!isProtectArea">
			<div class="retranslation_btn"
				:class="{ 'retranslation_btn_active': jsonList.length || editPdfCount == sunEditPdfCount }"
				@click="handleRetranslation">
				{{ retranslationBtnText }}
				<div class="retranslation_btn_tips regional_translation_tutorial" v-if="showBtnTooltips">
					{{ showBtnTooltipText }}
					<span class="triangle"></span>
				</div>
			</div>
			<el-tooltip class="box-item" effect="dark" placement="top" :popper-style="{ 'max-width': '450px', 'word-wrap': 'break-word' }"
				 show-arrow enterable>
				<i class="iconfont icon-icon_problem" />
				<template #content>
					<!-- <p @click="regionalTranslationTutorial" style="cursor: pointer;">{{
						$t('doclingo_regional_translation_tutorial') }}</p> -->
					<p>{{ $t('doclingo_regional_translation_tips1')}}</p>
					<p>{{ $t('doclingo_regional_translation_tips2')}}</p>
				</template>
			</el-tooltip>

		</div>

	</div>
	<teamCommonDialog v-if="editTipsShow" @onClose="onTipsClose" @onConfirm="onTipsConfirm"
		:confirmBtnTitle="confirmBtnTitle" sceneType="teamIndex" :isCloseShow="true">
		<div class="team_common_dialog_view">
			<div class="title">{{ $t('warmReminder') }}</div>
			<div class="subTitle" v-if='isTypeText == "vip"'>
				{{ $t('doclingo_up_vip_tips') }}
			</div>
			<div class="subTitle" v-if='isTypeText == "confirm"'>
				{{ $t('doclingo_regional_translation_confirm') }}
			</div>
		</div>
	</teamCommonDialog>
	<ProDialog v-if="showDialog" @onClose="hideProDialog" :parmas="currentPro" />
</template>

<script setup lang='ts'>
defineOptions({
	inheritAttrs: false
})

const teamCommonDialog = defineAsyncComponent(() => import("~/components/teamComponents/teamIndex/teamCommonDialog.vue"))
const ProDialog = defineAsyncComponent(() => import("@/components/Pro/ProDialog/ProDialog.vue"))

import { ref, unref, reactive, watch, defineComponent } from "vue";
 import { useI18n } from "vue-i18n";
 const { t, locale } = useI18n();

 import eventBus from "vue3-eventbus";
 import useUserStore from "@/store/modules/user";
 import useProStore from "@/store/modules/pro";
 import {storeToRefs} from "pinia";
 import _ from "lodash";
 // 在其他组件中使用
import { useDrawing } from '@/composables/useEditPdfDrawing'
// import { usePdfStore } from '@/store/pdfEditStore'
// const pdfEditStore = usePdfStore()

 const router = useRouter();
 const route = useRoute();
 const userStore = useUserStore();
 const userProStore = useProStore();
 const { userInfo }  = storeToRefs(userStore);

import { getDrawing, getAllDrawings, subscribe } from '@/composables/drawingManager'

// 定义事件
const emit = defineEmits<{
	(e: 'openRegionalTranslation', payload: { params: any }): void; // 按钮点击事件
	(e: 'updataJsonList'): void; // 画布更新数据监听事件，派发到外部用来显示右侧组件
}>();
interface RegionalEditItem {
	index: number;
	edit_rect_type: string;
	ignore_type: string;
	isPage?: string | boolean;
	data: any[];
	// id: string; // 添加唯一 ID 字段
}

interface RegionalListItem {
	page: number;
	canvasPage?: string; // 可选属性
  list: RegionalEditItem[];
}

interface Props {
	// editJsonData?: any;
	// fileJsonData?: any;
	editPdfCount:  number;
	editPdfLimitCfgJson: any;
	isProtectArea?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	isProtectArea: false
})



const editList = ref<any[]>([])
// page: 整页不翻译  rectangle: 矩形   line: 分割线
const jsonList = reactive<RegionalListItem[]>([])

// 如果watch监听不到，可以尝试使用这种方法来监听
// const list = computed(() => props.regionalEditObj)
// // 监听联动数据list的变化
// watch(list, (newVal) => {
// }, { deep: true, immediate: true })

// 深度拷贝数据， 防止对源数据进行处理， 影响页面交互
async function deepCloneWithPromises(obj) {
	// 处理基本类型和非对象类型
	if (obj === null || typeof obj !== 'object') {
		return obj;
	}
	// 处理数组
	if (Array.isArray(obj)) {
		const results = await Promise.all(obj.map(item => deepCloneWithPromises(item)));
		return results;
	}
	// 处理对象
	const clonedObj = {};
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			if (value instanceof Promise) {
				// 等待 Promise 完成
				clonedObj[key] = await value;
			} else {
				clonedObj[key] = await deepCloneWithPromises(value);
			}
		}
	}
	return clonedObj;
}

interface RegionalEditItem {
	index: number;
	edit_rect_type: string;
	ignore_type: string;
	isPage?: string | boolean;
	data: any[];
}
// 把原数据转成右侧显示的数据格式。
function transformToTargetFormat(data) {
	const result: RegionalListItem[] = [];
	for (const [key, value] of Object.entries(data)) {
		// 类型断言确保 value 是 RegionalEditItem 数组
		const typedValue = value as RegionalEditItem[];
		// 如果 value 是空数组，则跳过
		if (typedValue.length === 0) {
			continue;
		}
		const pageNumber = parseInt(key.split('-')[2]); // 获取页码
		const pageData: RegionalListItem = {
			page: pageNumber,
			canvasPage: key,
			list: typedValue.map(item => ({
				index: item.index,
				edit_rect_type: item.edit_rect_type,
				ignore_type: item.ignore_type,
				isPage: item.isPage ? '' : undefined, // 如果 isPage 为 true，则设置为空字符串
				data: item.data
			}))
		};
		result.push(pageData);
	}
	return result;
}
// 把显示的数据格式， 转回原始数据格式
function transformToOriginalFormat(data) {
	const result = {};
	data.forEach(item => {
		const key = `canvas-page-${item.page}`;
		result[key] = item.list.map(({ index, edit_rect_type, ignore_type, isPage, data }) => ({
			index,
			edit_rect_type,
			ignore_type,
			isPage: isPage === '' ? true : false, // 这里假设 isPage 为 '' 的时候表示 true
			data
		}));
	});
	return result;
}


// 右侧底部按钮文案。
const retranslationBtnText = computed(() => {
	return `${t('accountResetTranslate')} ${props.editPdfCount}/${sunEditPdfCount.value}`
})
// 来显示菜单名称
const pageTypeTextfilter = (typeStr: string, index: number) => {
	let arr = [{ key: 'line', value: t('doclingo_line') }, { key: 'rectangle', value: t('doclingo_rectangle') }, { key: 'page', value: t('doclingo_full_page') }]
	const matched:any = arr.find(item => item.key === typeStr)
	if (typeStr === 'page'){
		return `${t('doclingo_full_page') }`
	}
	return `${matched.value}${index+1}`
}

const selected = ref<number>(1)

// 区域翻译教程事件，跳转到教程界面
const regionalTranslationTutorial = () => {

}


//总调整次数 （翻译数量）  props.editPdfCount  //已调整次数
const sunEditPdfCount = computed(() => {
	if (userInfo.value.vipLevel === 0) {
		return props.editPdfLimitCfgJson.pdfEditAreaLimit_user
	} else {
		return props.editPdfLimitCfgJson.pdfEditAreaLimit_vip
	}
})


const showBtnTooltipText = computed(()=>{
	// 已翻译次数，如果等于总翻译次数，则显示“同一文件只能重新翻译3次”
	if (props.editPdfCount === sunEditPdfCount.value){
		return t("doclingo_sameFile_translated_three_times").replace("*",sunEditPdfCount.value)
	}
	if (jsonList.length == 0) {
		return t('doclingo_not_adjustment_item')
	}
	
})
const tooltipTimeout = ref<ReturnType<typeof setTimeout> | null>(null)


// 重新翻译 按钮事件
const handleRetranslation = () => {
	
	// 灰色按钮时的点击提示
	if (jsonList.length == 0 || (props.editPdfCount == sunEditPdfCount.value) ){

		showBtnTooltips.value = true
		// 先清理旧定时器（避免重复）
		if (tooltipTimeout.value) {
			clearTimeout(tooltipTimeout.value)
		}
		tooltipTimeout.value = setTimeout(() => {
			showBtnTooltips.value = false
			tooltipTimeout.value = null
		}, 3000)
		return;
	}
	// 如果没有进入上面的判断条件， 这里显示的关闭popoverRef
	showBtnTooltips.value = false
	// 未开通会员时提示
	if (userInfo.value.vipLevel < 1 && userInfo.value.validWordsForBag <= 0) {
		isTypeText.value = 'vip'
		editTipsShow.value = true
		return;
	}
	isTypeText.value = 'confirm'
	editTipsShow.value = true

	
}

// 转成后台需要的数据格式并且输出
function transformData(inputData) {
	const result = {};
	inputData.forEach(item => {
		const pageKey = item.page.toString(); // 将页码转换为字符串作为键
		const transformedList = item.list.map(entry => {
			const editRectType = entry.edit_rect_type === 'rectangle' ? 'area' : entry.edit_rect_type;
			return {
				data: entry.data.flat(),
				edit_rect_type: editRectType,
				ignore_type: entry.ignore_type // 统一设置 ignore_type 为 "all"
			}
			
		});
		// 如果该页还没有被添加到结果中，则初始化
		if (!result[pageKey]) {
			result[pageKey] = [];
		}
		// 将转换后的数据添加到对应的页中
		result[pageKey] = transformedList;
	});
	return result;
}

const isTypeText = ref('confirm')
const showBtnTooltips = ref(false)
const editTipsShow = ref(false)
const confirmBtnTitle = computed(()=>{
  if(isTypeText.value === 'vip'){
    return t('chat_porary_buy_vip')
  }else{
    return t('confirm')
  }
})
// 关闭弹窗
const onTipsClose = () => {
	editTipsShow.value = false;
}
// 公共弹窗确认事件，升级会员
const onTipsConfirm = () => {
	if(isTypeText.value == 'vip'){
		onPro()
	}else{
		console.log(JSON.parse(JSON.stringify(jsonList)))
		let req = transformData(jsonList)
		console.log('req==', req)
		// 弹出重新翻译弹窗
		emit('openRegionalTranslation', {params:req})
	}
	
	onTipsClose()
}

const showDialog = ref(false)
let currentPro = ref({})
// 订阅
function onPro() {
	let configKey = userStore.getCurrentCoin(locale.value)
	let membersConfig = userProStore.getProConfig('vip-1month', 'vip-month', configKey)
	showDialog.value = true
	currentPro.value = { type: 1, currency: configKey, purchaseType: 'year', config: membersConfig }
}
const hideProDialog = () => {
	showDialog.value = false
}
let unsubscribe = () => { } // 初始化一个空函数防止未定义错误
onBeforeUnmount(() => {
	if (tooltipTimeout.value) {
		clearTimeout(tooltipTimeout.value)
	}
	if (initTimeout.value) {
		clearTimeout(initTimeout.value)
		initTimeout.value = null
	}
	unsubscribe()
})



const handleDeleteItem = (pageItem, modeType, item, pageIndex) => {
	const shapeIndex = Math.max(0, Number(item.index) - 1)
	handleDeleteLine(pageItem.page, modeType, shapeIndex, pageIndex, pageItem.canvasPage)
}

// 删除第 2 页的第 0 条线
function handleDeleteLine(index: number, type: string, idx: number, pageIndex:number, canvasId?: string) {
	console.log('pageItem.page==', index, 'type===>', type, 'idx==>>', idx)
  const drawing = getDrawing(canvasId || `canvas-page-${index}`)
	
  if (drawing) {
		console.log('drawing===', drawing.instance)
		if(type == 'line'){
			const lines = unref<any>(drawing.instance.lines)
			lines.splice(idx, 1)
			drawing.instance.lines.value = lines
		} else if (type == 'rectangle'){
			const rects = unref<any>(drawing.instance.rects)
			rects.splice(idx, 1)
			drawing.instance.rects.value = rects
		} else if (type == 'page'){
			drawing.instance.clearPageFlag(index);
			jsonList.splice(pageIndex,1)
			console.log('jsonList==>', jsonList)
		}
		eventBus.emit('deleteItem',{
			type,
			index
		})
		drawing.instance.redrawAll()
  }
}



const initTimeout = ref<ReturnType<typeof setTimeout> | null>(null)
const feedbackCanvasViewData = (delay: number = 500) => {
	// 清除之前的定时器
	if (initTimeout.value) {
		clearTimeout(initTimeout.value)
		initTimeout.value = null
	}

	initTimeout.value = setTimeout(async () => {
		try {
			const allDrawings = getAllDrawings()
			const result: Record<string, any> = {}
			console.log('allDrawings===>>', allDrawings)
			for (const id in allDrawings) {
				const index = id.split('-').pop()
				result[id] = allDrawings[id].exportAllData()
			}
			console.log('result======?????', result)
			const deepCopied = await deepCloneWithPromises(result)
			console.log("Deep Copied:", deepCopied)

			const transformedData = transformToTargetFormat(deepCopied)
			jsonList.splice(0) // 清空原数组内容
			updateJsonListPreservingState(transformedData)
		} catch (err) {
			console.error('Error:', err)
		}
	}, delay)
}

onMounted(() => {
	// 初始加载时延迟执行一次,加载数据
	feedbackCanvasViewData(0) 
	const drawingUnsubscribe = subscribe((id, data, event) => {
		console.log(`[Drawing Update] ID: ${id}, Event: ${event}`, data)
		const allDrawings = getAllDrawings()
		const result: Record<string, any> = {}
		for (const id in allDrawings) {
			const index = id.split('-').pop();
			result[id] = allDrawings[id].exportAllData()
		}
		console.log('发布数据==', result)

		deepCloneWithPromises(result).then(deepCopied => {
			console.log("Deep Copied:", deepCopied);

			const transformedData = transformToTargetFormat(deepCopied)
			jsonList.splice(0); // 清空原数组内容
			// jsonList.push(...transformedData); // 替换为新数据
			updateJsonListPreservingState(transformedData);
			
		}).catch(err => {
			console.error('Error:', err);
		});
	})
	unsubscribe = typeof drawingUnsubscribe === 'function' ? drawingUnsubscribe : () => { }; // 将返回的取消订阅函数赋值给变量
})
const isUpdataJsonShow = ref(false) //用来设置样式使用
// 因为每次更新原数据， 必须清空一次渲染的数据， 如果不清空， 可能会叠加
// 函数用来对比旧数据和新数据，并只更新变化的部分：
function updateJsonListPreservingState(newData: RegionalListItem[]) {
	console.log('newData===>', newData)
	const nextPages = new Set(newData.map(item => item.page.toString()))
	for (let index = jsonList.length - 1; index >= 0; index -= 1) {
		if (!nextPages.has(jsonList[index].page.toString())) jsonList.splice(index, 1)
	}
	const existingMap = new Map<string, RegionalListItem>(jsonList.map(item => [item.page.toString(), item]));

	newData.forEach(newItem => {
		const existingItem = existingMap.get(newItem.page.toString());

		if (existingItem) {
			// 页面存在，检查 list 是否有变化
			const getShapeKey = (it: RegionalEditItem) => `${it.edit_rect_type}:${it.index}`
			const existingListMap = new Map(existingItem.list.map(it => [getShapeKey(it), it]));
			const newListMap = new Map(newItem.list.map(it => [getShapeKey(it), it]));

			// 删除不存在的项（倒序，避免连续删除时跳项）
			for (let index = existingItem.list.length - 1; index >= 0; index -= 1) {
				if (!newListMap.has(getShapeKey(existingItem.list[index]))) existingItem.list.splice(index, 1)
			}

			// 替换或新增项
			newItem.list.forEach(newIt => {
				const existingIt = existingListMap.get(getShapeKey(newIt));
				if (existingIt) {
					Object.assign(existingIt, newIt); // 保留引用地址
				} else {
					existingItem.list.push(newIt);
				}
			});
		} else {
			// 页面不存在，直接添加
			jsonList.push(newItem);
		}
	})
	jsonList.sort((a, b) => a.page - b.page)
	// if (newData.length){
	// 	isUpdataJsonShow.value = true;
	// }
	
	console.log('监听画布事件成功～～～～')
	emit("updataJsonList")
}

// 修改canvas中的 线段或者矩形的 某个数据属性
function updateShapeIgnoreType(pageId: any, idx: number, ignoreType:string, modeType) {
	console.log('pageId=', pageId, 'idx==', idx, 'ignoreType===', ignoreType)
	const drawing = getDrawing(pageId)
	if (drawing) {
		return drawing.updateShapeIgnoreType(modeType ,idx-1, ignoreType)
	}
}

defineExpose({
	jsonList
})



</script>

<style scoped lang='less'>
.regionalTranslationRightView{
	transition:  0.5s all;
	width:320px;
	background-color: #fff;
	height:calc(100%);
	font-size: 14px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	.rightView_body{
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		padding: 20px 10px;
		position: relative;
	}
	.pageItem{
		margin-bottom: 10px;
		border-bottom: 1px solid var(--input-bg-color);
	}
	.pageItem:last-child{
		margin-bottom: 10px;
	}
	.pageItem_title_view{
		width: 92%;
		justify-content: space-between;
		padding:5px 10px;
		color: var(--text-color2);
	}
	.pageItem_list_view{
		width: 92%;
		color:var(--text-color2);
		padding: 5px 10px;
		justify-content: space-between;
		.pageItem_list_item_select{
			margin-right:20px;
		}
		.custom-select{
			width: 120px;
			color: var(--text-color);
		}
		.pageItem_list_item_delete{
			cursor: pointer;
		}
	}
	.common_display {
		display: flex;
		align-items: center;
	}
	.retranslation_btn_view{
		flex: 0 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 12px 10px 20px;
		border-top: 1px solid var(--input-bg-color);
		i{
			margin-left: 15px;
			font-size: 18px;
			cursor: pointer;
		}
	}
	.retranslation_btn{
		min-width: 150px;
		height: 40px;
		line-height: 40px;
		background-color: var(--progress-bg-color);
		text-align: center;
		font-size: 14px;
		border-radius: 4px;
		color:#fff;
		cursor: pointer;
		position: relative;
		.retranslation_btn_tips{
			position: absolute;
			top:-50px;
			width:200px;
			height:auto;
			font-size: 14px;
			background-color: var(--text-color);
			color:#fff;
			border-radius: 8px;
			.triangle {
				width: 0;
				height: 0;
				border-left: 5px solid transparent; // 左边透明
				border-right: 5px solid transparent; // 右边透明
				border-top: 5px solid var(--text-color); // 底边为白色（三角主体）
				position: absolute;
				bottom: -5px; // 父元素底部对齐
				left: 30%; // 水平居中
				transform: translateX(-30%); // 微调水平居中
				z-index: 1;
			}
		}
	}
	.retranslation_btn_active{
		background-color: var(--progress-bg-color);
		color: #fff;
	}
	
}
.setWidth{
	width: 350px;
	overflow-y: auto;
}
.setBtnShow{
	display: flex !important;
}

.not_data{
	position: absolute;
	top:50%;
	left:0;
	right:0;
	transform: translateY(-50%);
	padding:30px;
	text-align: center;

	.not_data_title{
		font-size: 16px;
		line-height: 18px;
	}
	.not_data_desc {
		margin-top: 15px;
		font-size: 14px;
		line-height: 18px;
		color: var(--text-color3);
	}

}



.team_common_dialog_view {
	width: 100%;

	.title {
		font-size: 16px;
		font-weight: bold;
		color: var(--text-color);
		margin: 40px 0 20px 0;
		text-align: center;
	}

	.subTitle {
		// width: 94%;
		margin: 5px 0;
		text-align: center;

		span {
			display: inline-block;
			color: var(--progress-bg-color);
		}

		.setColor {
			color: var(--progress-bg-color);
			text-decoration: none;
		}

	}
}
</style>
<style>
.regionalTranslationRightView .custom-select {
	border: none;
	color: var(--text-color) !important;
	/* 去掉边框 */
}
.regionalTranslationRightView .select__selected-item{
	color: var(--text-color) !important;
}
.regionalTranslationRightView .el-select__placeholder{
	color: var(--text-color) !important;
}
.regionalTranslationRightView .el-select__wrapper{
	border: none;
	box-shadow:none !important;
	color: var(--text-color) !important;
}

.regionalTranslationRightView .custom-select .el-input {
	border: none;
	/* 去掉输入框的边框 */
	box-shadow: none;
	/* 去掉阴影效果 */
	color: var(--text-color) !important;
}
.regionalTranslationRightView .custom-select .el-input:focus {
	outline: none !important;
	box-shadow: none !important;
	border-color: inherit !important;
}

</style>
